import { Row, Col, Card, CardBody, Container } from "reactstrap";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getGuestPermitRequest } from "../../api/controller/PermitController";

const ViewPermit = () => {
  const [ref, setRef] = useState(null);
  const [data, setData] = useState([]);
  const params = useParams();

  useEffect(() => {
    setRef(params.ref);
  }, [params.ref]);

  useEffect(() => {
    async function fetchData(refferenceNo) {
      let postData = { ref: refferenceNo };
      setData([]);
      const response = await getGuestPermitRequest(postData);
      if (response && response.Status !== "error") {
        setData(response.data);
        console.log(response.data);
      } else {
        // console.log('No Data');
        setData([]);
      }
    }
    if (ref) {
      fetchData(ref);
    }
  }, [ref]);

  return (
    <React.Fragment>
      <div>
        {data ? (
          <Row style={{ justifyContent: "center" }}>
            <Col md={4}>
              <Container style={{marginTop:'20px'}}>
                <Card>
                  <CardBody>
                    <h3>VIA AIRSIDE ACCESS PERMIT</h3>
                    <Row>
                      <Col>
                        <Row>
                          <span>Company Name: {data.creator?.name}</span>
                        </Row>
                        <Row>
                          <span>Staff Name: {data.name}</span>
                        </Row>
                        <Row>
                          <span>ID Card No: {data.identification_number}</span>
                        </Row>
                        <Row>
                          <span>Designation: {data.designation}</span>
                        </Row>
                        <Row>
                          <span>Validity: {data.validity}</span>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Container>
            </Col>
          </Row>
        ) : (
          <Container fluid>
            <h3>INVALID REQUEST</h3>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default ViewPermit;
